import styled from "styled-components"

export const Line = styled.hr`
  border: 0;
  height: ${({ height }: { height: string}) => height};
  width: ${({width}) => width || "0px"};
  background: ${({ color, theme }) =>
    color ? color : theme.palette.text.primary};
`
